export default __webpack_public_path__ + "static/media/logo.ecbc31d9.png";